/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssignMadrasaExaminersRequest } from '../models/AssignMadrasaExaminersRequest';
import type { CreateMadrasaExamRequest } from '../models/CreateMadrasaExamRequest';
import type { DuplicateMadrasaExamRequest } from '../models/DuplicateMadrasaExamRequest';
import type { MadrasaExamDto } from '../models/MadrasaExamDto';
import type { MadrasaExaminerResponse } from '../models/MadrasaExaminerResponse';
import type { MadrasaExamLiteResponse } from '../models/MadrasaExamLiteResponse';
import type { Page_GroupedSubjectMadrasaExamSummaryProjection_ } from '../models/Page_GroupedSubjectMadrasaExamSummaryProjection_';
import type { SortMadrasaExamRequest } from '../models/SortMadrasaExamRequest';
import type { StaffLiteDto } from '../models/StaffLiteDto';
import type { UpdateMadrasaExamRequest } from '../models/UpdateMadrasaExamRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MadrasaExamRestControllerService {
  /**
   * createMadrasaExam
   * @returns MadrasaExamDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static createMadrasaExamUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: CreateMadrasaExamRequest;
  }): CancelablePromise<MadrasaExamDto | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/madrasa-exam',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * updateMadrasaExam
   * @returns MadrasaExamDto OK
   * @throws ApiError
   */
  public static updateMadrasaExamUsingPatch({
    request,
  }: {
    /**
     * request
     */
    request: UpdateMadrasaExamRequest;
  }): CancelablePromise<MadrasaExamDto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/madrasa-exam',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

  /**
   * duplicate
   * @returns any OK
   * @throws ApiError
   */
  public static duplicateUsingPost1({
    request,
  }: {
    /**
     * request
     */
    request: DuplicateMadrasaExamRequest;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/madrasa-exam/duplicate',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getExaminers
   * @returns StaffLiteDto OK
   * @throws ApiError
   */
  public static getExaminersUsingGet({
    classLevelId,
  }: {
    /**
     * classLevelId
     */
    classLevelId: string;
  }): CancelablePromise<Array<StaffLiteDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/madrasa-exam/examiners',
      query: {
        classLevelId: classLevelId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * assignExaminers
   * @returns MadrasaExaminerResponse OK
   * @returns any Created
   * @throws ApiError
   */
  public static assignExaminersUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: AssignMadrasaExaminersRequest;
  }): CancelablePromise<MadrasaExaminerResponse | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/madrasa-exam/examiners',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * sortMadrasaExams
   * @returns any OK
   * @throws ApiError
   */
  public static sortMadrasaExamsUsingPut({
    request,
  }: {
    /**
     * request
     */
    request: SortMadrasaExamRequest;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/madrasa-exam/reorder-exams',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * filterSubjectExamSummaries
   * @returns Page_GroupedSubjectMadrasaExamSummaryProjection_ OK
   * @throws ApiError
   */
  public static filterSubjectExamSummariesUsingGet({
    limit = 10,
    offset,
    search,
  }: {
    /**
     * limit
     */
    limit?: number;
    /**
     * offset
     */
    offset?: number;
    /**
     * search
     */
    search?: string;
  }): CancelablePromise<Page_GroupedSubjectMadrasaExamSummaryProjection_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/madrasa-exam/subject-exam-summaries',
      query: {
        limit: limit,
        offset: offset,
        search: search,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * filterExams
   * @returns MadrasaExamLiteResponse OK
   * @throws ApiError
   */
  public static filterExamsUsingGet({
    subjectId,
    search,
  }: {
    /**
     * subjectId
     */
    subjectId: string;
    /**
     * search
     */
    search?: string;
  }): CancelablePromise<Array<MadrasaExamLiteResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/madrasa-exam/subject/{subjectId}',
      path: {
        subjectId: subjectId,
      },
      query: {
        search: search,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * toggleStudentsAlwaysReady
   * @returns any OK
   * @throws ApiError
   */
  public static toggleStudentsAlwaysReadyUsingPut(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/madrasa-exam/toggle-students-readiness',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getMadrasaExam
   * @returns MadrasaExamDto OK
   * @throws ApiError
   */
  public static getMadrasaExamUsingGet({
    examId,
  }: {
    /**
     * examId
     */
    examId: string;
  }): CancelablePromise<MadrasaExamDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/madrasa-exam/{examId}',
      path: {
        examId: examId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * deleteExam
   * @returns any OK
   * @throws ApiError
   */
  public static deleteExamUsingDelete1({
    examId,
  }: {
    /**
     * examId
     */
    examId: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/madrasa-exam/{examId}',
      path: {
        examId: examId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
}
